import React, { useEffect, useState } from "react";
import SearchResultCardComponent from "../../Components/card/searchResultCard";
import { getUserData } from "../../Utils/localStorageUtils";
import { getUserShortlistedProperties } from "../../services/shortlistService";
const DataTableSection = ({ searchResults = [] }) => {
  const { _id: userId } = getUserData() || {}; // Get user ID
  const [shortlistedPropertyIds, setShortlistedPropertyIds] = useState(new Set()); // ✅ Store only IDs
  const [loading, setLoading] = useState(true); // ✅ Loading state
  // Fetch user's shortlisted properties once
  useEffect(() => {
    if (!userId) {
      setLoading(false); // ✅ If no user, stop loading
      return;
    }


    const fetchShortlist = async () => {
      try {
        const data = await getUserShortlistedProperties(userId);
        setShortlistedPropertyIds(new Set(data.propertyIds)); // ✅ Store only IDs in a Set for quick lookup
      } catch (error) {
        console.error("Error fetching shortlisted properties:", error);
      }finally {
        setLoading(false); // ✅ Stop loading after API call
      }
    };

    fetchShortlist();
  }, [userId]); // ✅ Runs once when userId changes

  return (
    <div>
      {loading ? (
        <p>Loading shortlisted properties...</p> // ✅ Show loading message
      ) : (
        searchResults?.map((item) => (
          <div key={item._id} className="py-2">
            <SearchResultCardComponent
              property={item}
              isShortlisted={shortlistedPropertyIds.has(item._id)} // ✅ Pass shortlist state as prop
            />
          </div>
        ))
      )}
    </div>
  );
};

export default DataTableSection;
